<div class="ui-g">

  <div class="ui-g-12">
    <div class="main-topic-panel">
      <h1 class="primary-color" style="font-size: 100px">
        404
      </h1>
      <h1 class="primary-color">
        NOT FOUND
      </h1>
      <div class="ui-g">
        <div class="ui-g-12">
          <h3 class="show-on-desktop" style="text-align: center; margin-top: -25px">
            The person or organisation you are looking for is not recorded in the system.
          </h3>
        </div>
      </div>
    </div>
  </div>
</div>


